import {combineReducers} from 'redux';
import counter from "./counter";
import appState from "./appState";
import login from "./login";
import brokerStatus from "./brokerStatus";
import brokerLogs from "./brokerLogs";
import chatLogs from "./chatLogs";
import devzone from "./devzone";
import scriptingConsole from "./scriptingConsole";

const rootReducer = combineReducers({
    appState,
    counter,
    login,
    brokerStatus,
    brokerLogs,
    chatLogs,
    devzone,
    scriptingConsole
});

export default rootReducer;
